module.exports = __webpack_public_path__ + "media/tacklebox/assets/images/views/search/bannerSp-55d464c61af7cde4fb7747660500b123.webp";